import React from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
//windowsize
import useWindowSize from "../../Component/use-window-size";

const TaxableIncome = () => {
  //get current windowsize
  const size = useWindowSize();
  const taxableIncome = useSelector(
    (state) => state.salaryCalculation.taxableIncome
  );
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);


  const outputElement = {
    backgroundColor: "#f8f9fa",
    borderColor: "#f8f9fa",
    transition: "0.5s",
    color: "#777",
    cursor: "default",
    overflow: "hidden",
    whiteSpace: "nowrap"
  };

  return (
    <>
      {size.width < sizeForMobile ? (
        <Row className="g-0 mt-2 m-auto rounded-3 card-salaryCalculation">
          <Col
            xs={40}
            className="p-1 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={{
              color: "#777",
              overflow: "hidden",
              whiteSpace: "nowrap",
              cursor: "default",
            }}
          >
            Beskattningsbar Inkomst
          </Col>
          <Col xs={20} className="offset-10" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              ={" "}
              {taxableIncome > 0 || taxableIncome < 0
                ? Math.round(taxableIncome)
                : 0}
            </output>
          </Col>
        </Row>
      ) : (
        <Row className="g-0 mt-2 m-auto rounded-3 card-salaryCalculation">
          <Col
            xs={17}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={{
              color: "#777",
              overflow: "hidden",
              whiteSpace: "nowrap",
              cursor: "default",
            }}
          >
            Beskattningsbar Inkomst
          </Col>
          <Col xs={7} className="offset-16 p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              ={" "}
              {taxableIncome > 0 || taxableIncome < 0
                ? Math.round(taxableIncome)
                : 0}
            </output>
          </Col>
        </Row>
      )}
    </>
  );
};
export default TaxableIncome;
